import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useToast } from '@/components/common/Toast';
import { sellerService } from '@/services/seller';
import { useSellerStore } from '@/store/seller';
import { DesktopSellerPageContainer } from '@/components/desktop/DesktopSellerPageContainer';
import { OrderCompleteConfirmModal } from '@/components/seller/modals/OrderCompleteConfirmModal';

export function DesktopOrderCompletePage() {
  const { orderId } = useParams<{ orderId: string }>();
  const navigate = useNavigate();
  const { showToast, ToastContainer } = useToast();
  const { updateOrderStatus } = useSellerStore();

  const [showModal, setShowModal] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!orderId) {
      showToast('주문 정보를 찾을 수 없습니다');
      return;
    }

    setLoading(true);
    try {
      const result = await sellerService.updateOrderStatus(orderId, {
        status: 'READY'
      });

      if (result.success) {
        // 스토어 상태 업데이트
        updateOrderStatus(orderId, 'READY');
        
        showToast('주문 준비가 완료되었습니다');
        navigate('/seller/home');
      } else {
        showToast(result.error || '주문 완료 처리에 실패했습니다');
      }
    } catch (error) {
      console.error('Order complete error:', error);
      showToast('주문 완료 처리 중 오류가 발생했습니다');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    navigate(`/seller/orders/${orderId}`);
  };

  return (
    <DesktopSellerPageContainer>
      <OrderCompleteConfirmModal
        isOpen={showModal}
        onClose={handleClose}
        onConfirm={handleConfirm}
        loading={loading}
      />
      <ToastContainer />
    </DesktopSellerPageContainer>
  );
}